import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';

const investorProfileFields: Record<
  keyof GetBoInvestorProfileIdEndpoint['Client']['ResponseBody'],
  string
> = {
  id: 'Id du profil',
  b2b_contract_id: 'ID du contrat',
  allocation_instruments: 'Nombre de fonds',
  allocations: 'Allocation',
  name: 'Nom du profil',
  plan_category: 'Plan',
  plan_ids: 'ID(s) du plan',
  risk_profile: 'Profil de risque',
};

export const b2bInvestorProfileTranslations = {
  fields: investorProfileFields,
  list: {
    allocation_nbr: 'Nombre de fonds',
    plan_category: 'Plan',
    plan_ids: 'ID(s) du plan',
    empty: "Cette société n'a aucun profil d'investissement",
  },
  risk_profile: {
    balanced: 'Équilibré',
    careful: 'Prudent',
    dynamic: 'Dynamique',
    sicav: 'Retraite SICAV',
  },
  create: {
    title: "Créer un profil d'investissement",
    product_category: 'Catégorie de Produit',
    name: 'Nom du profil',
    template: "Template du profil d'investissement",
    grid_configuration: {
      title: 'Configuration du profil',
      subtitle: 'Utilisez les filtres pour sélectionner le groupe de destinataires',
      add_assets: 'Ajouter des fonds',
      years_before_retirement: 'Années avant retraite',
    },
    sicav_grid_configuration: {
      retirement_year: 'Année de retraite',
      placement_support: 'Support d’investissement',
      instrument_placeholder: 'Ajouter un fond',
      add_row: 'Ajouter une ligne',
    },
  },
  menu: {
    investor_profile: "Profils d'investissement",
  },
};
